import { useEffect, useRef, useState } from "react";

import { useApolloClient } from "@apollo/client";

import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

/** contexts */
import { useSettings } from "../../context/settings";

/** QUERIES MUTATIONS */
import { SENDPUSH } from "../../provider/Users/query";

/** utils */
import { getGraphsqErros } from "../../utilities/functions";
import { InputTextarea } from "primereact/inputtextarea";
import { useUser } from "../../context/users";
import FRANCHISE_REGIONS from "../../provider/Franchises/Regions/query";
import { Dropdown } from "primereact/dropdown";

const Crud = () => {
  const settings = useSettings();
  const apollo = useApolloClient();

  const user = useUser();
  const franchise_id = user?.getUser()?.franchise?.id;
  const acting_region_id = user?.getUser()?.actingRegion?.id;

  const [franchise, setFranchise] = useState<any>(null);
  const [franchises, setFranchises] = useState<iFranchise[]>([]);
  const [region, setRegion] = useState<any>(null);
  const [regions, setRegions] = useState<iRegion[]>([]);
  const [load, setLoad] = useState(true);
  const [reload, setReload] = useState<boolean>(false);

  const toast = useRef<any>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');

  const loadFranchises = (_useLoad: boolean = true) => {
    if (_useLoad) setLoad(true);
    
    const filter: any = {};
  
    if (franchise_id) filter.franchise_id = Number(franchise_id);

    if (franchise?.code) filter.franchise_id = Number(franchise.code);

    apollo
      .query({
        query: FRANCHISE_REGIONS,
        variables: {
          ...filter,
        },
        fetchPolicy: "no-cache",
      })
      .then(response => {
        setFranchises(response.data.franchises || []);
        setRegions(response.data.regions || []);

        setLoad(false);
        setReload(false);
      })
      .catch(error => {
        console.log('FRANCHISE_REGIONS error', JSON.stringify(error));
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
        setLoad(false);
        setReload(false);
      });
  }

  const sendPush = (topassenger: boolean = false) => {
    setLoading(true);

    const variables: any = {
      title,
      message,
      topassenger,
    }

    if (franchise_id) variables.franchise_id = Number(franchise_id);

    if (acting_region_id) variables.acting_region_id = Number(acting_region_id);

    if (franchise?.code) variables.franchise_id = Number(franchise.code);

    if (region?.code) variables.acting_region_id = Number(region.code);

    apollo
      .query({
        query: SENDPUSH,
        variables: {
          ...variables,
        },
        fetchPolicy: "no-cache",
      })
      .then(_response => {
        setLoading(false);

        toast.current.show({
          severity: "success",
          summary: "Sucesso",
          detail: `Mensagem enviada para todos os ${topassenger ? 'passageiros' : 'motoristas'}!`,
          life: 3000,
        });
      })
      .catch(error => {
        console.log('SENDPUSH error: ', JSON.stringify(error));
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
        setLoading(false);
      });
  }

  useEffect(() => {
    loadFranchises();
  }, []);

  useEffect(() => {
    if (franchise?.code){
      setRegion(null);
      setReload(true);
      loadFranchises(false);
    }
  }, [franchise?.code]);

  return (
    <div className="card">
      <Toast ref={toast} />
      {franchise_id && acting_region_id ? null : (
        load ? (
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
        ) : (
          <>
            <div className="card">
              <div className="flex flex-column md:flex-row flex-wrap">
                { !franchise_id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Franquia</label>
                    <div className="field col-12 md:col-12">
                      <Dropdown
                        value={franchise}
                        onChange={e => setFranchise(e.value)}
                        options={franchises.map(i => ({ code: i.id, name: i.name }))}
                        optionLabel="name"
                        placeholder="Selecione uma Franquia"
                      />
                    </div>
                  </div>
                ) : null }
  
  
                { !acting_region_id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Região</label>
                    <div className="field col-12 md:col-12">
                      {reload ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                      ) : (
                        <Dropdown
                          value={region}
                          onChange={e => setRegion(e.value)}
                          options={regions.map(i => ({ code: i.id, name: i.name }))}
                          optionLabel="name"
                          placeholder="Selecione uma Região"
                        />
                      )}
                    </div>
                  </div>
                ) : null }
              </div>
            </div>
          </>
        )
      )}
      <div className="grid p-fluid mt-3">
        <div className="field col-12 md:col-4">
          <span className="p-float-label">
            <InputText type="text" id="inputtext" value={title} onChange={e => setTitle(e.target.value)} />
            <label htmlFor="inputtext">Título</label>
          </span>
        </div>
      </div>
      <div className="field col-12 md:col-4">
        <span className="p-float-label">
          <InputTextarea id="textarea" rows={3} cols={60} value={message} onChange={e => setMessage(e.target.value)}></InputTextarea>
          <label htmlFor="textarea">Mensagem</label>
        </span>
      </div>
      <div className="card">
        <Button
          icon="pi pi-car"
          label="Motoristas"
          className="p-button-rounded mr-2 mb-2"
          onClick={() => sendPush()}
          disabled={loading}
        />
        <Button
          icon="pi pi-user"
          label="Passageiros"
          className="p-button-rounded p-button-info mr-2 mb-2"
          onClick={() => sendPush(true)}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default Crud;
